module.exports = __webpack_public_path__ + "static/media/internal_projects.7e52a0c2.svg";